import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCopyControlLookup extends Layout {
    sourceCopyControlLookup: DataSource;
    table1: Table;
}
